import { Unverified as PoaUnverified } from './unverified';

export default PoaUnverified;
